export default "__VITE_ASSET__njS4DayU__"